module.exports = __webpack_public_path__ + "img/phone.e110e0ac.png";